window.addEventListener('load', function() {
  var swiper = new Swiper('.top002', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
	disableOnInteraction: true,
    loop: false,
	spaceBetween: 0,
    slidesPerView: 2.6,
    
	breakpoints: {
     768: {  // 横幅が768px以下で、下記設定に書き換える。
              slidesPerView: 1.2,
              spaceBetween: 0,
				},
			},
  });
}, false);